function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5309 132.598C5.04663 134.986 -0.578539 139.623 0.0474493 147.929C0.653675 155.973 5.95946 163.137 12.6835 167.651C19.4077 172.165 27.4299 174.359 35.4108 175.811C64.4649 181.096 94.3839 181.763 123.793 179.65C153.346 177.526 183.41 178.942 213.194 177.272C232.042 176.215 250.89 175.159 269.738 174.102C284.44 173.278 299.198 172.447 313.653 169.646C320.343 168.35 327.202 166.509 332.41 162.137C337.617 157.764 340.695 150.225 338.009 143.997C335.906 139.12 330.737 136.064 325.472 135.2C320.206 134.336 314.818 135.342 309.644 136.643C294.391 140.478 279.829 146.889 264.377 149.84C250.355 152.517 235.943 152.277 221.682 151.562C172.428 149.095 123.65 141.111 74.8033 134.361C64.4237 132.927 32.1164 127.367 13.5309 132.598Z",
  fill: "#E5E9F0",
  fillOpacity: 0.3
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.994 93.4494C121.994 105.047 131.396 114.449 142.994 114.449H189.258C200.856 114.449 210.258 105.047 210.258 93.4494V21C210.258 9.40201 200.856 0 189.258 0H142.994C131.396 0 121.994 9.40202 121.994 21V93.4494Z",
  fill: "#F3F5FB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.873 35.6414C176.087 36.0977 179.301 36.5541 182.515 37.0104C185.563 37.4431 188.63 37.877 191.706 37.7565C189.625 30.3999 188.499 24.306 185.782 17.9092C183.659 20.4911 172.794 35.6303 172.873 35.6414Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.926 49.6699C130.981 51.3981 127.789 55.927 128.994 61.1924C129.637 64.0011 131.419 66.3428 133.597 67.6443C137.769 70.137 143.988 69.6117 146.976 64.9384C149.005 61.7638 149.264 56.9804 147.607 53.494C145.291 48.6205 139.485 47.6728 134.926 49.6699Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.514 77.0603C193.321 83.4877 192.579 89.9975 192.291 96.5402C185.499 95.278 178.63 94.4258 171.748 93.9912C172.615 94.0427 174.348 76.346 174.639 74.6388C174.665 74.4887 174.699 74.3247 174.832 74.2328C174.961 74.1428 175.145 74.1495 175.312 74.1599C176.994 74.2654 194.742 75.7579 194.514 77.0603Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.2413 95.1417H229.935V87.8662H72.2413V95.1417Z",
  fill: "#EBEEF4"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.9264 159.782H88.8294V94.3022H82.9264V159.782Z",
  fill: "#EBEEF4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.966 85.6274H106.384C105.691 85.6274 105.13 86.1912 105.13 86.8868C105.13 87.5821 105.691 88.1459 106.384 88.1459H167.966C168.658 88.1459 169.22 87.5821 169.22 86.8868C169.22 86.1912 168.658 85.6274 167.966 85.6274Z",
  fill: "#DEE7EE"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.164 85.6266H144.202L133.593 63.7583C133.024 62.5862 131.829 61.8413 130.519 61.8413H95.0872C94.4103 61.8413 93.9655 62.5433 94.2591 63.1489L105.164 85.6266Z",
  fill: "#DEE7EE"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.994 74.8234C117.404 75.5652 118.025 75.9927 118.382 75.7779C118.738 75.5626 118.695 74.7871 118.285 74.0452C117.874 73.3033 117.253 72.8759 116.896 73.0906C116.54 73.3057 116.584 74.0815 116.994 74.8234Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.689 26.2379C166.409 26.1861 166.128 26.1368 165.846 26.0898",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.438 25.8752C158.842 24.9769 152.948 25.4713 147.995 28.1606C142.831 30.9644 138.958 36.4521 138.859 42.254",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "5.05 5.05"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.699 42.8132C138.707 43.0927 138.723 43.3726 138.745 43.6527",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.129 70.5168C145.138 70.8038 145.178 71.0837 145.242 71.3563",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.885 72.4751C145.999 72.6564 146.119 72.834 146.24 73.0074C148.766 76.6406 152.099 79.764 156.075 81.6801C159.613 83.3853 163.675 84.087 167.529 83.4172",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "5.07 5.07"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.373 83.3317C168.655 83.2816 168.937 83.2268 169.217 83.1669",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.673 43.0935C193.867 43.1781 194.054 43.2717 194.236 43.3733",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.36 44.2126C196.901 45.5562 197.966 47.4628 198.748 49.3641C201.879 56.9756 201.703 65.81 198.323 73.3147",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4.96 4.96"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.891 74.1541C197.8 74.3417 197.706 74.5283 197.61 74.7137",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.42,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.6729 36.4952C40.0192 36.2932 40.3911 36.086 40.793 36.0992C41.231 36.1136 41.6117 36.386 41.9603 36.6489C46.107 39.7797 50.0285 43.2031 53.6851 46.8841C48.9804 46.1624 43.9658 47.8266 40.652 51.2093C37.6968 47.3821 33.7071 45.9578 29.2299 44.792C30.0244 41.2063 36.8802 38.1236 39.6729 36.4952Z",
  fill: "#E5E9F0"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.42,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.8863 57.4156C70.4325 56.97 72.7623 55.9125 75.0375 54.5654C75.2606 56.9933 73.0583 60.7041 72.193 63.0828C71.859 64.0002 71.497 64.9465 70.7975 65.6298C69.8324 66.572 68.413 66.8434 67.0809 67.0712C63.1012 67.7527 58.8609 69.0354 54.8145 68.3716C57.4572 66.8997 60.5704 65.9213 62.4745 63.4407C63.7992 61.7151 64.6163 59.6652 65.417 57.6443C66.2647 57.6352 67.0865 57.5554 67.8863 57.4156Z",
  fill: "#E5E9F0"
});

var SvgMourOptionsOfficeSpace = function SvgMourOptionsOfficeSpace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 199,
    height: 181,
    viewBox: "0 0 199 181",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMourOptionsOfficeSpace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mour-options-office-space.d824b013.svg";
export { ForwardRef as ReactComponent };